import dayjs from 'dayjs';

export function formatLogValue(value: any): string {
  const formattedString = String(value);

  // quando timezone
  if (
    formattedString.includes('T') &&
    formattedString.includes('Z') &&
    formattedString.includes(':')
  ) {
    return dayjs(value).format('DD/MM/YYYY HH:mm');
  }

  // eslint-disable-next-line default-case
  switch (value) {
    case true:
      return 'sim';
    case false:
      return 'não';
    case null:
      return 'nulo';
  }

  return value;
}

// eslint-disable-next-line consistent-return
export function getFieldNames(fieldName: string) {
  // eslint-disable-next-line default-case
  switch (fieldName) {
    case 'name':
      return 'nome';
    case 'title':
      return 'título';
    case 'description':
      return 'descrição';
    case 'start_at':
      return 'ínicio';
    case 'original_name':
      return 'nome';
    case 'duration':
      return 'duração';
    case 'has_invite':
      return 'invite';
    case 'local_address':
      return 'endereço';
    case 'link_address':
      return 'link de acesso';
    default:
      return fieldName;
  }
}
